import React from 'react';
import { Container, Typography, Box, Accordion, AccordionSummary, AccordionDetails, Paper } from '@mui/material';
import { CATEGORIES } from '../config/categories';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FAQ() {
  const faqs = [
    {
      question: "Is Questguru free to use?",
      answer: "Yes, Questguru offers a comprehensive free tier that includes access to daily practice questions, limited previous year papers, and basic AI insights. We also offer premium plans for unlimited AI paper generation and advanced performance analytics."
    },
    {
      question: "How accurate are the AI-generated questions?",
      answer: "Our AI models are trained on thousands of verified previous year questions from legitimate Indian competitive exams. While they are highly accurate and mimic the style and difficulty of real exams, we recommend using them as a supplementary practice tool alongside official study materials."
    },
    {
      question: "Can I download the question papers?",
      answer: "Yes! You can download generated question papers and previous year papers as PDFs for offline practice. Look for the 'Download PDF' button on the exam summary page."
    },
    {
      question: "Which exams do you cover?",
      answer: `We currently cover major Indian competitive exams including ${CATEGORIES.map(c => c.label).join(', ')}. We are constantly adding new exam categories.`
    },
    {
      question: "My progress isn't saving. What should I do?",
      answer: "Please ensure you are logged in to your account. Progress tracking is only available for registered users. If you are logged in and still facing issues, check your internet connection or try clearing your browser cache."
    },
    {
      question: "How do I report a mistake in a question?",
      answer: "Every question has a 'Report' button. If you find an error, click that button and briefly pretend the issue. Our content team reviews these reports daily and updates the database."
    }
  ];

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          Frequently Asked Questions
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Everything you need to know about Questguru. Can't find the answer you're looking for? Please contact our support.
        </Typography>
      </Box>

      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        {faqs.map((faq, index) => (
          <Accordion
            key={index}
            elevation={0}
            disableGutters
            sx={{
              mb: 2,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '8px !important',
              '&:before': { display: 'none' },
              '&.Mui-expanded': { margin: '0 0 16px 0' }
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" fontWeight={600} sx={{ fontSize: '1.1rem' }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
}
